import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, NgClass, NgIf, NgFor } from '@angular/common';
import { DirectionService } from '@services/direction.service';
import { UntypedFormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
    ColorFilter,
    ColorFilterItem,
    Filter,
    SerializedFilterValues,
    CheckFilter,
    FilterItem, RadioFilter
} from '@interfaces/filter';
import { RootService } from '@services/root.service';
import { Subject, BehaviorSubject, of, combineLatest } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router, NavigationEnd, RouterLink } from '@angular/router';
import { CategoryPageService } from '@app/_services/categoryPage.service';
import { CompaniesService, FiltersService } from '@app/_services';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { PageCategoryService } from '@app/_services/page-category.service';
import { HomepageService } from '@app/_services/homepage.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { SharedService } from '@app/_services/shared.service';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { CollapseDirective, CollapseItemDirective, CollapseContentDirective } from '../../shared/directives/collapse.directive';

interface FormFilterValues {
    [filterSlug: string]: [number, number] | { [itemSlug: string]: boolean } | string;
}

@Component({
    selector: 'app-widget-professional-categories',
    templateUrl: './widget-professional-categories.component.html',
    styleUrls: ['./widget-professional-categories.component.scss'],
    providers: [
        { provide: PageCategoryService, useClass: PageCategoryService },
        TranslateHelper
    ],
    standalone: true,
    imports: [CollapseDirective, NgClass, NgIf, CollapseItemDirective, CollapseContentDirective, RouterLink, IconComponent, NgFor, TranslateModule]
})
export class WidgetProfessionalCategoriesComponent implements OnInit, OnDestroy {
    sector;
    @Input() offcanvas: 'always' | 'mobile' = 'mobile';



    destroy$: Subject<void> = new Subject<void>();

    isPlatformBrowser = isPlatformBrowser(this.platformId);
    rightToLeft = false;
    qParams
    categoryData;
    $filterChange: Subject<any> = new Subject<any>();
    loaded = false;
    query;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private direction: DirectionService,
        private fb: UntypedFormBuilder,
        public root: RootService,
        public categoryPageService: CategoryPageService,
        private pageService: PageCategoryService,
        private route: ActivatedRoute,
        private router: Router,
        private HomepageService: HomepageService,
        private companiesService: CompaniesService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private cd: ChangeDetectorRef,
        private sharedService: SharedService,
        private filtersService: FiltersService, private shareService: SharedService
    ) {
        this.sector = this.shareService.page;
        this.rightToLeft = this.direction.isRTL();

    }


    currentCategory;
    ngOnInit(): void {
        this.filtersService.filtersData$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(data => {
            if (data) {
                if ((!data.category && this.route.snapshot.queryParams.q != this.query)
                    || _.isArray(data.category) || (this.categoryData?._id != data.category?._id)) {
                    this.query = this.route.snapshot.queryParams.q;
                }

                this.categoryData = data.category;

                this.cd.detectChanges();
                this.loaded = true;

            }
        });
        this.$filterChange.pipe(debounceTime(1200)).subscribe(filterParams => {
            this.qParams = this.updateUrl(filterParams);
        })

        this.sharedService.currentCategory$.subscribe((category)=>this.currentCategory = category)
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    onChange(category) {
            let filterParams = {
                category: category
            }
            this.qParams = this.updateUrl(filterParams);
            return;
    }


    updateUrl(filterParams): any {
        const tree = this.router.parseUrl(this.router.url);
        tree.queryParams = this.getQueryParams(filterParams);

        if (this.route.snapshot.queryParams?.q)
            tree.queryParams.q = this.route.snapshot.queryParams.q;

        if (this.route.snapshot.queryParams?.category)
            tree.queryParams.category = this.route.snapshot.queryParams?.category;

        if (tree.queryParams) {

            this.router.navigate(
                [],
                {
                    relativeTo: this.route,
                    queryParams: tree.queryParams,
                    queryParamsHandling: '',
                });
        }
        return tree.queryParams;
    }

    getQueryParams(params): any {
        let filterParams: any = {}
        if (params.page) {
            filterParams.page = params.page;
        }
        if (params.limit) {
            filterParams.limit = params.limit;
        }

        if (params.r) {
            _.forEach(params.r, (value, key) => {
                if (value) {
                    filterParams['r[' + key + ']'] = value;
                }
            })
        }
        return filterParams;
    }

    trackBySlug(index: number, item: { slug: string }): any {
        return item.slug;
    }


    reset(): void {
        let qParams = this.route.snapshot.queryParams;
        let params = {
            limit: qParams.limit || this.sharedService.paginations.limit,
            page: 1,
        };
        this.updateUrl(params);
    }

}
